import { Alert, Loader } from "@mantine/core";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Navigate } from "react-router-dom";
import { useMe } from "./me";
import { useSession } from "./session";

/** SignedIn renders its children for a signed-in person and sends anyone else to sign in. */
export function SignedIn({ children }: { children: ReactNode }) {
  const session = useSession();
  if (session.status === "loading") return null;
  if (session.status === "signed-out") return <Navigate to="/signin" replace />;
  return <>{children}</>;
}

/** AdminOnly renders its children only for a platform administrator (ARC-05). */
export function AdminOnly({ children }: { children: ReactNode }) {
  const { t } = useTranslation();
  const me = useMe();
  return (
    <SignedIn>
      {me.isPending ? (
        <Loader size="sm" aria-label={t("common.loading")} my="xl" />
      ) : me.data?.role === "platform_admin" ? (
        children
      ) : (
        <Alert color="red" role="alert" my="xl" data-testid="not-admin">
          {t("admin.not_admin")}
        </Alert>
      )}
    </SignedIn>
  );
}
